import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17l9 5l9 -5v-3l-9 5l-9 -5v-3l9 5l9 -5v-3l-9 5l-9 -5l9 -5l5.418 3.01","key":"svg-0"}]]

/**
 * IconBrandDatabricks
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZGF0YWJyaWNrcyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyAxN2w5IDVsOSAtNXYtM2wtOSA1bC05IC01di0zbDkgNWw5IC01di0zbC05IDVsLTkgLTVsOSAtNWw1LjQxOCAzLjAxIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-databricks
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandDatabricks = createReactComponent('outline', 'brand-databricks', 'BrandDatabricks', __iconNode);

export default IconBrandDatabricks;